var centerGradientImage = "/static/844563f89ca83922.png";

export { centerGradientImage as default };
//# sourceMappingURL=gradient_right.png.js.map
